import { connect } from "react-redux";
import { createSelector } from "reselect";
import translationService from "../../app/TranslationService";
import InternalStateService from "../../app/InternalStateService";
import { useCallback, useEffect, useRef } from "react";

export const UnloadMessageContainer = (props) => {
    const willMount = useRef(true);
    const executedOnce = useRef(false);
    let unsavedChangesWarnings;
    if (willMount.current) {
        unsavedChangesWarnings =
            InternalStateService.getGlobalProperties("unsavedChangesWarnings") !== undefined
                ? InternalStateService.getGlobalProperties("unsavedChangesWarnings")
                : true;
    }
    const onbeforeunload = useCallback(() => {
        if (props.updateMode) {
            return translationService.translate("unsavedChanges");
        }
    }, [props]);

    useEffect(() => {
        if (!executedOnce.current) {
            executedOnce.current = true;
            if (unsavedChangesWarnings) {
                window.onbeforeunload = onbeforeunload;
            }
        }
        return () => {
            if (unsavedChangesWarnings) {
                window.onbeforeunload = undefined;
            }
        };
    });

    willMount.current = false;

    return null;
};

UnloadMessageContainer.displayName = "UnloadMessageContainer";

const getUpdateStateSelector = (state) => state.getIn(["global", "applicationUpdateMode"]);
const mapStateToProps = createSelector([getUpdateStateSelector], (updateMode) => {
    return {
        updateMode
    };
});

export default connect(mapStateToProps)(UnloadMessageContainer);
